import { atomWithImmer } from 'jotai-immer';
import { atom } from 'jotai';
import { CrashHistoryItem, GameStatus } from '../types/crash';
import { CrashBetRecordsBetItem, CrashGameRankItem } from '@/apis/casino/crash';
import { atomWithStorage } from 'jotai/utils';

/* ====================== *
 *    layout state
 * ====================== */

export const widthState = atomWithImmer<number>(750);

export const heightState = atomWithImmer<number>(Math.floor(750 * 0.52));

/* ====================== *
 *    game state
 *
 * ====================== */

export const gameIdAtom = atomWithImmer<string>('crash');
export const gameRoundIdAtom = atomWithStorage('gameRoundId', 1);

export const gameStatusState = atomWithImmer<GameStatus>(GameStatus.Init);
export const countdownState = atomWithImmer<number>(20);
export const timeState = atomWithImmer<number>(0);
export const crashedTimeState = atomWithImmer<number | null>(null);

export const multiplierState = atomWithImmer<number>(1);
export const showWinCelebrationState = atomWithImmer<boolean>(false);
export const finalProfitState = atomWithImmer<number>(0);

/* ====================== *
 *    player operation data
 * ====================== */
// export const betValueState = atomWithStorage<number>('betValue', -1);
export const bettedAmountState = atomWithImmer(-1);

export const noBetState = atom((get) => get(bettedAmountState) === -1);
export const nextRoundBetValueState = atomWithImmer(-1);
export const noNextRoundBetState = atom(
  (get) => get(nextRoundBetValueState) === -1,
);

export const autoCrashOutAtState = atomWithImmer(false);

// export const stopAtState = atomWithStorage('stopAt', 2);
export const stopAtState = atomWithImmer(null);

// history list,only store the latest five historical records
export const crashHistoryState = atomWithImmer<CrashHistoryItem[]>([]);

/* ====================== *
 *    game setting
 * ====================== */
export const autoBetState = atomWithImmer(false);

export const maxBetState = atomWithImmer(true);
export const gameVolumeState = atomWithStorage('volume', 20);

/* ====================== *
 *    member
 * ====================== */
export const gameMembers = atomWithImmer<CrashBetRecordsBetItem[]>([]);

/**
 *
 */
export const crashedMemberAtom = atomWithImmer<CrashBetRecordsBetItem[]>([]);
